import { FC } from "react";
import styled from "styled-components";

import { VideoFramesExportStatus } from "@/utils/enums";

const StatusText = styled.span`
  display: flex;
  align-items: center;
  svg {
    margin-right: 6px;
  }
`;

interface Props {
  status: VideoFramesExportStatus;
}

const ExtractorStatus: FC<Props> = ({ status }) => {
  switch (status) {
    case VideoFramesExportStatus.FAILED:
      return (
        <StatusText>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
              fill="#F64629"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.71064 5.70711C10.1012 5.31658 10.1012 4.68342 9.71064 4.29289C9.32011 3.90237 8.68695 3.90237 8.29642 4.29289L7.00177 5.58755L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L5.58755 7.00177L4.29289 8.29642C3.90237 8.68695 3.90237 9.32011 4.29289 9.71064C4.68342 10.1012 5.31658 10.1012 5.70711 9.71064L7.00177 8.41598L8.29642 9.71064C8.68695 10.1012 9.32011 10.1012 9.71064 9.71064C10.1012 9.32011 10.1012 8.68695 9.71064 8.29642L8.41598 7.00177L9.71064 5.70711Z"
              fill="white"
            />
          </svg>
          Failed
        </StatusText>
      );
    case VideoFramesExportStatus.IN_PROGGRESS:
      return (
        <StatusText>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
              fill="#F0AD1C"
            />
            <path
              d="M10.6 7.50001H7V3.40001"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          In progress
        </StatusText>
      );
    case VideoFramesExportStatus.COMPLETED:
      return (
        <StatusText>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
              fill="#42BE77"
            />
            <path
              d="M9.96214 5.38461L6.0134 9.15384L4.03906 7.26923"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Done
        </StatusText>
      );
    default:
      return null;
  }
};

export default ExtractorStatus;
